
import sirepAPI from "@/api/sirepApi";
import sirepApiFiles from "@/api/sirepApiFiles"

export const getRelatives = async ({commit}, id_persona) => {
    try {
        const { data } = await sirepAPI.get("/modulo_social/obtener_familiares/"+id_persona)
        return {data}         
    } catch (error) {
        return {message:error}
    }
}
export const saveContactPpl = async ({commit}, value) => {
    try {
        console.log("value", value);
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.post("/modulo_social/registrar_contacto_familiar/"+nro_documento, value)
        return {data}
    } catch (error) {
        return {message:error}
    }
}
export const saveEditedPplContact = async ({commit}, value) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.put("/modulo_social/editar_contacto_familiar/"+nro_documento, value)
        return {data}
    } catch (error) {
        return {message:error}
    }
}








export const getSubAsistencia = async ({commit}, id_asistencia_principal) => {
    try {
        const { data } = await sirepAPI.get("/modulo_social/obtener_sub_asistencia/"+id_asistencia_principal)
        return {data}         
    } catch (error) {
        return {message:error}
    }
}
export const getAsistencia = async ({commit}, id_sub_asistencia) => {
    try {
        const { data } = await sirepAPI.get("/modulo_social/obtener_asistencia/"+id_sub_asistencia)
        return {data}         
    } catch (error) {
        return {message:error}
    }
}
export const savePplAttendance = async ({commit}, value) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.post("/modulo_social/registrar_asistencia_ppl/"+nro_documento,value)
        return {data}
    } catch (error) {
        return {message:error}
    }
}
export const getPplAttendance = async ({commit}, id_centro_penitenciario) => {
    try {
        const { data } = await sirepAPI.get("/modulo_social/obtener_atenciones_psicologicas_ppl/"+id_centro_penitenciario)
        return {data}         
    } catch (error) {
        return {message:error}
    }
}





export const getAreaFormacion = async ({commit}) => {
    try {
        const { data } = await sirepAPI.get("/modulo_educativo/obtener_area_formacion")
        return {data}         
    } catch (error) {
        return {message:error}
    }
}
export const saveInstitution = async ({commit}, value) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.post("/modulo_educativo/registrar_institucion/"+nro_documento,value)
        return {data}
    } catch (error) {
        return {message:error}
    }
}
export const getInstitutions = async ({commit}, departamento_centro_penitenciario) => {
    try {
        const { data } = await sirepAPI.get("/modulo_educativo/obtener_instituciones/"+departamento_centro_penitenciario)
        return {data}         
    } catch (error) {
        return {message:error}
    }
}

export const deleteInstitution = async ({commit}, id_institucion) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.patch("/modulo_educativo/eliminar_institucion/"+nro_documento, {id_institucion})
        return {data}
    } catch (error) {
        return {message:error}
    }
}

export const saveCourse = async ({commit}, value) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.post("/modulo_educativo/registrar_curso/"+nro_documento,value)
        return {data}
    } catch (error) {
        return {message:error}
    }
}
export const getCourses = async ({commit}, id_centro_penitenciario) => {
    try {
        const { data } = await sirepAPI.get("/modulo_educativo/obtener_cursos/"+id_centro_penitenciario)
        return {data}         
    } catch (error) {
        return {message:error}
    }
}
export const editCourse = async ({commit}, value) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.put("/modulo_educativo/editar_curso/"+nro_documento, value)
        return {data}
    } catch (error) {
        return {message:error}
    }
}
export const deleteCourse = async ({commit}, id_asignatura) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.patch("/modulo_educativo/eliminar_asignatura/"+nro_documento, {id_asignatura})
        return {data}
    } catch (error) {
        return {message:error}
    }
}


export const getTeachers = async ({commit}, id_centro_penitenciario) => {
    try {
        const { data } = await sirepAPI.get("/modulo_educativo/obtener_profesores/"+id_centro_penitenciario)
        return {data}         
    } catch (error) {
        return {message:error}
    }
}
export const deleteTeacherById = async ({commit}, id_profesor) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.patch("/modulo_educativo/eliminar_profesor/"+nro_documento, {id_profesor})
        return {data}
    } catch (error) {
        return {message:error}
    }
}
export const deleteTeacherCourseById = async ({commit}, {id_profesor_asignatura, id_profesor}) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.patch("/modulo_educativo/eliminar_asignatura_profesor/"+nro_documento, {id_profesor_asignatura, id_profesor })
        return {data}
    } catch (error) {
        return {message:error}
    }
}


export const saveStudent = async ({commit}, value) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.post("/modulo_educativo/registrar_estudiante/"+nro_documento,value)
        return {data}
    } catch (error) {
        return {message:error}
    }
}
export const getStudents = async ({commit}, id_centro_penitenciario) => {
    try {
        const { data } = await sirepAPI.get("/modulo_educativo/obtener_estudiantes/"+id_centro_penitenciario)
        return {data}         
    } catch (error) {
        return {message:error}
    }
}
export const editStudent = async ({commit}, value) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.put("/modulo_educativo/editar_estudiante/"+nro_documento, value)
        return {data}
    } catch (error) {
        return {message:error}
    }
}
export const deleteStudentById = async ({commit}, id_estudiante_asignatura) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.patch("/modulo_educativo/eliminar_estudiante/"+nro_documento, {id_estudiante_asignatura})
        return {data}
    } catch (error) {
        return {message:error}
    }
}

